import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { GqlPlannerV2ShiftCreateFromVisitInput } from "~/__generated__";

import { PlannerV2_GetPendingChangesDocument } from "../../queries.generated";
import { PlannerV2ShiftCreateFromVisitDocument } from "../mutations.generated";
import { PlannerV2FieldworkersGetPlannableForVisitDocument, PlannerV2VisitGetByIdDocument } from "../queries.generated";

export default function usePlannerV2CreateShift() {
    const [mutate, { data, loading, error }] = useMutation(PlannerV2ShiftCreateFromVisitDocument, {
        refetchQueries: [
            PlannerV2VisitGetByIdDocument,
            PlannerV2FieldworkersGetPlannableForVisitDocument,
            PlannerV2_GetPendingChangesDocument,
        ],
        awaitRefetchQueries: true,
    });

    const createShift = useCallback(
        async (input: GqlPlannerV2ShiftCreateFromVisitInput) => {
            const response = await mutate({ variables: { input } });
            return response.errors === undefined;
        },
        [mutate],
    );

    return {
        createShift,
        data,
        loading,
        error,
    };
}
